import React from 'react'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import { Select, TextField } from '@material-ui/core'
import { colors, theme } from '../Global'
import StyledSwitch from './Switch'

export const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      type="text"
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({ target: { value: values.value } })
      }}
      thousandSeparator
    />
  )
}

export const LabelStyle = styled.label`
  ${(props) => (props.padding ? `
    padding: ${props.padding};
    display: inline-block;
  ` : null)}
  font-weight: 500;
  color: ${theme.colors.text};
`

export const StyledInlineSelect = styled(Select)`
  display: inline-block !important;
  background: ${colors.white};
  border: 1px solid ${colors.darkGrey};
  color: ${theme.colors.text};
  width: 100%;
  line-height: 1.7rem !important;
  > div {
    padding: 0.25rem 0 0.25rem 0.25rem;
  }
`

export const FilledInputStyle = styled(TextField)`
  --vertical-padding: 0.25rem;
  width: 100%;
  
  && {
    input {
      padding: var(--vertical-padding);
      height: 2rem;
      color: ${theme.colors.text};
    }
    div {
      margin-top: 0.2rem;
      margin-bottom: 0.5rem;
      padding: var(--vertical-padding);
      border: 1px solid ${colors.darkGrey};
      background-color: ${colors.white};
      border-radius: 0;
    }
  }
`
export const SmartHelper = styled.span`
  transition: opacity 0.25s;
  color: ${theme.colors.text};
  opacity: 0;
  ${FilledInputStyle}:hover & {
    opacity: 1;
  }
`

export const isNumber = (val) => (String(val).match(/^[0-9]*$/))

export const isEmail = (val) => (String(val).match(/^[a-zA-Z0-9.!#$%&’*+/=?^_'{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/))

export { StyledSwitch }
